<!-- 项目文件 -->
<template>
    <div class="posre">
                <Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color" :img="bgImg"></Header>
        <div class="w100p bgfff">
            <div class="pt30 pb20 w1200 mauto">
                <div class="textc mt20 mb20 ">
                    <p class="fs36 c333 disinblock posre">
                        <span class="border-bottom1">
                            学车技巧
                        </span>
                    </p>
                </div>
                <div class="w100p pt20">
                    <ul class="disinblock w100p overflow">
                        <li @click="open(0)" style="background: #fb7777;" class="w16p cursor ml40 mt40 floatl disinblock bradius5 pt30 pb30 pl30 pr30">
                            <p>
                                <img class="w38 h30" src="../../public/img/01.png" alt="">
                            </p>
                            <p class="fs20 cfff fbold pt20 pb20">
                                交规巧记忆
                            </p>
                            <P class="cfff fs14">
                                点击查看>>
                            </P>
                        </li>
                        <li @click="open(1)"  style="background: #24c7da;" class="w16p cursor ml40 mt40 floatl disinblock bradius5 pt30 pb30 pl30 pr30">
                            <p>
                                <img class="w38 h30" src="../../public/img/02.png" alt="">
                            </p>
                            <p class="fs20 cfff fbold pt20 pb20 " style="white-space:nowrap;">
                                八种交警手势信号口诀
                            </p>
                            <P class="cfff fs14">
                                点击查看>>
                            </P>
                        </li>
                        <li  @click="open(2)" style="background: #f99411;" class="w16p cursor ml40 mt40 floatl disinblock bradius5 pt30 pb30 pl30 pr30">
                            <p>
                                <img class="w38 h30" src="../../public/img/03.png" alt="">
                            </p>
                            <p class="fs20 cfff fbold pt20 pb20">
                                处罚相关题巧记
                            </p>
                            <P class="cfff fs14">
                                点击查看>>
                            </P>
                        </li>
                        <li  @click="open(3)" style="background: #ee7cfc;" class="w16p cursor ml40 mt40 floatl disinblock bradius5 pt30 pb30 pl30 pr30">
                            <p>
                                <img class="w38 h30" src="../../public/img/04.png" alt="">
                            </p>
                            <p class="fs20 cfff fbold pt20 pb20">
                                罚款金额题巧记
                            </p>
                            <P class="cfff fs14">
                                点击查看>>
                            </P>
                        </li>
                        <li  @click="open(4)" style="background: #5acb5a;" class="w16p cursor ml40 mt40 floatl disinblock bradius5 pt30 pb30 pl30 pr30">
                            <p>
                                <img class="w38 h30" src="../../public/img/05.png" alt="">
                            </p>
                            <p class="fs20 cfff fbold pt20 pb20">
                                最低/最高时速题巧记
                            </p>
                            <P class="cfff fs14">
                                点击查看>>
                            </P>
                        </li>
                        <li @click="open(5)"  style="background: #bc7cfc;" class="w16p cursor ml40 mt40 floatl disinblock bradius5 pt30 pb30 pl30 pr30">
                            <p>
                                <img class="w38 h30" src="../../public/img/06.png" alt="">
                            </p>
                            <p class="fs20 cfff fbold pt20 pb20">
                                安全距离题巧记
                            </p>
                            <P class="cfff fs14">
                                点击查看>>
                            </P>
                        </li>
                        <li @click="open(6)"  style="background: #81a0ff;" class="w16p cursor ml40 mt40 floatl disinblock bradius5 pt30 pb30 pl30 pr30">
                            <p>
                                <img class="w38 h30" src="../../public/img/07.png" alt="">
                            </p>
                            <p class="fs20 cfff fbold pt20 pb20">
                                日期类题巧记
                            </p>
                            <P class="cfff fs14">
                                点击查看>>
                            </P>
                        </li>
                        <li  @click="open(7)" style="background: #ffc001;" class="w16p cursor ml40 mt40 floatl disinblock bradius5 pt30 pb30 pl30 pr30">
                            <p>
                                <img class="w38 h30" src="../../public/img/08.png" alt="">
                            </p>
                            <p class="fs20 cfff fbold pt20 pb20">
                                易混淆知识
                            </p>
                            <P class="cfff fs14">
                                点击查看>>
                            </P>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="posfix bgrg w100p h100p zindex999 pl10 pr10 overflow top0 left0  " v-show="mask==1">
            <div class="posab left20p top30p bgfff w50p pt20 pb20 pl40 pr40 bradius8 maxh300" >
                <span @click="choose()" class="disinblock posab top0 right11 fs26 c333 cursor"> × </span>
                <div class="pt20 pb20 maxh250 gundong" v-for="(item,index) in list" :key="index" v-if="index==idd" style="overflow-y: auto;">
                    <p class="pt5 pb5" v-for="(v,i) in item.name">
                        {{v}}
                    </p>
                </div>
            </div>
        </div>
    <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header'
    import Footer from '@/components/Footer'
    import $ from "jquery";
    export default {
        data() {
            return {
                cityName: '',
                bgImg: require('../../public/img/img51.png'),
                color: 1,
                City: '',
                City1: 1,
                Lng: '',
                Lat: '',
                link: 2,
                titleList: 4,
                logo: 'home',
                mask: 0,
                idd: 0,
                list: [{
                    name: [
                        "1答题中所有题一个原则——安全，因此怎么做安全就怎么做。",
                        "2判断题中遇到紧急情况所有过激行为都错，比如急踩（用力踏）油门（制动），急转方向，选择题中类似的答案都错。",
                        "3能让行的都让行，能帮助的都帮助，能避让就避让，只要不抢、不急都对。",
                        '4抢救伤员一个原则先救人，救人一个原则先止血。',
                        "5无标志无灯无警路口，按照让右路——让左转——让直行的顺序判断。",
                        "6车辆变换位置都要开转向灯，唯一一个不开的就是进环岛（转盘）。",
                        "7红色是禁令、黄色是警告、蓝色是指示，三种颜色都没有是辅助。",
                        "8禁令对禁止、警告对警告、指示对指示，相同就对，不相同就错。",
                        "9黄灯亮与黄灯闪烁只一字之差。“闪烁”确保安全，“亮”不准通行，但越线的可通行。",
                        "10远光灯、近光灯的考题只能使用近光灯，不准使用远光灯。",
                        "11只有冰雪道路是下坡先行，其余都是上坡先行；如果出现两个上坡先行，就选字多的。",
                        "12省选省，无省选县。",
                        "13户籍地对户籍地，暂住地对暂住地。",
                    ]
                }, {
                    name: [
                        "1停止信号：左臂由前向上直伸，掌心向前；",
                        '2直行信号：两手平伸右手摆；',
                        '3左转弯信号：右臂向前平伸，左手向右摆动；',
                        '4右转弯信号：左臂向前平伸，右手向左摆动；',
                        '5左转弯待转信号：左臂向左平伸成45度，上下摆动；',
                        '6变道信号：右臂向前平伸，掌心向左，右臂向左水平摆动；',
                        '7减速慢行信号：右臂向右前方平伸，掌心向下，平直向下摆动；',
                        '8示意车辆靠边停车信号：左臂由前向上直伸，掌心向前，右臂向前摆动。',
                    ]
                }, {
                    name: [
                        "1扣留机动车：未悬挂车牌、检验合格标志、保险标志；未携带行驶证、伪造相关证件或使用其他车辆证件；在一个计分周期达到12分。",
                        "2收缴号牌：伪造或假冒车牌号。",
                        "3警告：不按规定挂号牌。",
                        "4拘留15天：未有有效驾驶证（被吊销、被暂扣等）、造成交通事故后逃逸但不构成犯罪（逃逸吊销，终身不能重新取得）。",
                        "5吊销：将车给没有驾驶资格的人、超速50 %、非法改装车辆、报废、无正当理由逾期不接受处理。",
                        "6有期徒刑：犯交通肇事罪的，处3年以下有期徒刑或者拘役；因交通事故逃逸致人死亡的，处7年以上15年以下。",
                    ]
                }, {
                    name: [
                        " 罚款5 - 50元：",
                        "  行人、乘车人、非机动车驾驶人违反道路交通安全法律、法规关于道路通行规定的。罚款20 - 200元：",
                        "1、违规停车不在现场的；",
                        "  2、违规停车在现场但拒绝驶离的；",
                        "无论是哪一科考试都需要现场核对考生的身份信息，因此考生需要本人携带身份证前往考场。考试之前会发放考试的其他材料，注意要与身份证放在一起，上车输入指纹便可以开始了。因此考生一定要带齐相关的证件，自信满满的步入考场。",
                        "3、未放置保险标志的。",
                        " 罚款200 - 500元：",
                        "  1、客运车辆超员，但没超过20％的；",
                        "  2、货运车辆超过核定载质量的，但没超过30％的。",
                        "罚款200 - 2000元：",
                        " 1、未取得机动车驾驶证、机动车驾驶证被吊销或者机动车驾驶证被暂扣期间驾驶机动车的；",
                        "  2、将机动车交由未取得机动车驾驶证或者机动车驾驶证被吊销、暂扣的人驾驶的；",
                        " 3、造成交通事故后逃逸，尚不构成犯罪的",
                        "4、机动车行驶超过规定时速50 % 的；",
                        " 5、强迫机动车驾驶人违反道路交通安全法律、法规和机动车安全驾驶要求驾驶机动车，造成交通事故，尚不构成犯罪的；",
                        " 6、违反交通管制的规定强行通行，不听劝阻的；",
                        "  7、故意损毁、移动、涂改交通设施，造成危害后果，尚不构成犯罪的；",
                        "8、非法拦截、扣留机动车辆，不听劝阻，造成交通严重阻塞或者较大财产损失的；",
                        " 9、非法安装警报器、标志灯具的。",
                        " 罚款500 - 2000元：",
                        "1、客运车辆超员20％以上，或违反规定载货；",
                        "2、货运车辆超过核定载质量30 % 或者违反载客。",
                        "罚款1000 - 2000元：",
                        "   1、饮酒后驾驶机动车的；",
                        "    2、因饮酒后驾驶机动车被处罚，再次饮酒后驾驶机动车的。",
                        "罚款2000 - 5000元：",
                        "  1、使用其他车辆的机动车登记证书、号牌、行驶证、检验合格标志、保险标志的；",
                        " 2、伪造、变造或者使用伪造、变造的机动车登记证书、号牌、行驶证、驾驶证的。",
                    ]
                }, {
                    name: [
                        " 1、 在没有限速标志、 标线的道路情况下的最高时速: 没有道路中心线的城市道路为30公里， 公路为40公里； 同方向只有一条机动车道的城市道路为50公里， 公路为70公里。",
                        " 2、 遇雾、 雨、 雪、 沙尘、 冰雹， 能见度在50米以内时， 最高时速30公里。",
                        " 3、 掉头、 转弯、 下陡坡时， 最高时速30公里。",
                        "4、 在冰雪、 泥泞的道路上行使时， 最高时速30公里。",
                        "  5、 牵引发生故障的机动车时， 最高时速30公里。",
                        "6、 进出非机动车道， 通过铁路道口、 急转弯、 窄路、 窄桥时， 最高时速30公里。",
                    ]
                }, {
                    name: [
                        "1、白天或夜间在公路上发生故障时，设警告标志位置为车后50～100米处。",
                        "2、使用软连接牵引装置时，两车之间的距离大于4米小于10米。",
                        " 3、夜间会车时，在距离150米以外改用近光灯。",
                        "  4、在交叉路口、急弯路、窄桥、桥梁、陡坡、铁道路口、隧道，50米以内不得停车。",
                        "   5、在公交汽车站、急救站、加油站、消防队（站），30米以内不得停车。"
                    ]
                }, {
                    name: [
                        "1事故后逃逸，不构成犯罪，并处15日以下拘留。",
                        "2小型车非营运从注册登记之日起，6年以内每2年检验1次。",
                        "3小型车非营运从注册登记之日起，超过6年不满15年的，每1年检验一次。",
                        "4初次申领驾驶证后的12个月为实习期。",
                        "5机动车驾驶证有效期分为6年、10年和长期。",
                        "6道路交通安全违法行为累积记分周期为12个月。",
                        "7驾驶人不得连续驾驶超过4小时未停车休息。",
                        "8驾驶人连续驾车超过4小时，停车休息时间不得少于20分钟。",
                        "9以不正当手段取得机动车登记或者驾驶许可的，撤销，申请人3年内不得再申请。",
                        "10被扣留的机动车30日内不接受处理，公告3个月仍不接受处理的，依法拍卖。",
                        "11机动车驾驶人发生重大事故构成犯罪的，处3年以下有期徒刑。,",
                    ]
                }, {
                    name: [
                        "1、可以：应当在车身后部粘贴或者悬挂统一式样的实习标志。驾驶人在实习期内驾驶机动车上高速公路行驶，应当由持相应或者更高准驾车型驾驶证三年以上的驾驶人陪同。",
                        "2、不准：不得驾驶公共汽车、营运客车或者执行任务的警车、消防车、救护车、工程救险车以及载有爆炸物品、易燃易爆化学物品、剧毒或者放射性等危险物品的机动车；驾驶的机动车不得牵引挂车。",
                        "鸣喇叭：",
                        "1、可以：鸣三次，鸣半秒钟。行车中遇到畜力车时，尽量少鸣喇叭。",
                        "2、不准：郊外高音喇叭禁止，晚上23时到凌晨5时禁止。当经过不允许鸣喇叭的路段时，注意安全，禁止鸣喇叭。行进没有禁止鸣喇叭路段时，驾驶人应该尽可能少鸣喇叭。",
                        "灯光：",
                        "1、左转向灯：向左转弯、向左变道、起步、驶离停车地点、掉头时。",
                        "2、右转向灯：向右转弯、向右变道、靠边停车时。",
                        '3、夜间行车路灯照明良好开近光灯。',
                        '4、夜间无路灯照明时间时开远光灯。',
                        '5、雾天行驶时开雾灯和报警闪光灯。',
                        '6、进入环形路口不要开转向灯光，出环形路口时开右转向灯。',
                        '7、夜间需要超车时应变换远近光灯。',
                        '8、夜间临时停车时开示廓灯，后尾灯。',
                    ]
                }, ]
            };
        },
        components: {
            Header,
            Footer,
        },
        mounted() {

        },
        methods: {
            open(id) {
                this.mask = 1;
                this.idd = id;
                $('body').css("overflow", "hidden")
            },
            choose() {
                this.mask = 0;
                $('body').css("overflow", "auto")
            },

        },
        created() {
            this.cityName = this.$store.state.cityName;
        },
    }
</script>
<style scoped>
    .bgrg {
        background: rgba(0, 0, 0, 0.5);
    }
</style>